export const modules = [];
export const paths = [];
export const entries = paths.map((path, i) => [path, modules[i]]);